<template>
  <el-menu  class="el-menu-demo" mode="horizontal"  :default-active="activeIndex"     >
      
    <el-menu-item index="2" v-permission="['base&org']">
      <a :href="org">基础信息</a>
    </el-menu-item>
    <el-menu-item index="3" v-permission="['market']">
      <a  :href="market" >营销系统</a>
    </el-menu-item>
    <el-menu-item index="4" v-permission="['mws']">
      <a :href="wms" >wms系统</a>
    </el-menu-item> <el-menu-item index="1" v-permission="['home']" >
      <a  >追溯系统</a>
    </el-menu-item> 
  </el-menu>
</template>
<script>
import { generateTitle } from "@/utils/i18n";
import pathToRegexp from "path-to-regexp";
export default {
  data() {
    return {
     activeIndex: '1',
     home:process.env.VUE_APP_BASE_API,
     org:process.env.VUE_APP_BASE_API_org,
     market:process.env.VUE_APP_BASE_API_market,
     wms:process.env.VUE_APP_BASE_API_wms
    };
  },
  watch: {},
  methods: {}
};
</script>

<style lang="scss">
.el-menu--horizontal > .el-menu-item {
    float: left;
    height: 50px;
    line-height: 60px;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #909399;
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
